import { Canvas } from "@react-three/fiber";
import { Pepe } from "./Pepe";
import { Pepecoin } from "./Pepecoin";
import FloatingTitle from "./FloatingTitle";
import Laptop from "./Laptop";
import { Suspense, useRef } from "react";
import VideoTexture from "../VideoTexure";
import { observer } from "mobx-react";
import { DirectionalLight, Group, Object3DEventMap } from "three";
import { isMobile } from "../../utils/constants";

const Main = () => {
  return (
    <Canvas orthographic camera={{ position: [10, 0, 200], zoom: 60 }}>
      <mesh position={[0, 0, -8]} rotation={[0, 0, 0]}>
        <planeGeometry args={[40, 20]} />
        <Suspense fallback={<meshBasicMaterial wireframe />}>
          <VideoTexture src="/assets/videos/background.mp4" />
        </Suspense>
      </mesh>
      <Scene />
    </Canvas>
  );
};

const Scene = () => {
  const mobileScalingFactor = Math.min(
    Math.max(window.innerWidth / 1280, 0.5),
    1.2
  );

  const xPosition = window.innerWidth / -300;
  const floatingTitleRef = useRef<Group<Object3DEventMap>>(null);
  const directionalLightRef = useRef<DirectionalLight>(new DirectionalLight());
  return (
    <group position={[isMobile ? 2 : 0, 0, 0]}>
      <FloatingTitle
        ref={floatingTitleRef}
        scale={mobileScalingFactor}
        position={isMobile ? [-1.5, 3, 10] : [xPosition, 3.5, 0]}
      />
      <Pepe
        position={isMobile ? [-1.5, -4, 15] : [0, -2, -5]}
        rotation={[0, -2.25, 0]}
      />
      <Pepecoin
        scale={isMobile ? 1.5 : 2}
        position={isMobile ? [-1, -0.3, 0] : [-0.5, 2.5, 7]}
        rotation={[0, 2, 0]}
      />
      <Laptop
        scale={isMobile ? mobileScalingFactor : 0.8}
        position={isMobile ? [-3, 12, 15] : [-5, 0, 10]}
        rotation={[0, 4.25, 0]}
      />
      <directionalLight intensity={0.8} position={[0.5, -1, 0.866]} />
      <directionalLight
        ref={directionalLightRef}
        position={floatingTitleRef.current?.position}
        intensity={15}
      />
      <ambientLight intensity={5} />
      <color attach="background" args={["black"]} />
    </group>
  );
};

export default observer(Main);
